import { Wrapper } from "./styled";

const Loading = () => (
    <Wrapper>
        ⏳ Ładuję kursy walut z Europejskiego Banku Centralnego...
    </Wrapper>
);

export default Loading;
